import styles from './ServiceContractTable.module.scss';

import { Paper, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { TableInstance } from 'react-table';

import { EntityTable } from './EntityTable';

export const ServiceContractTable = React.forwardRef<
  TableInstance,
  EntityTable
>(() => {
  const { t } = useTranslation();

  return (
    <Paper className={styles.root}>
      <Typography className={styles.body2}>{t('MASK.WIP_WARNING')}</Typography>
    </Paper>
  );
});
